export { rgb2arr } from './rgb2arr';
export { gradient } from './gradient';
export { toRGB } from './torgb';
export { toCSSGradient } from './tocssgradient';
//# sourceMappingURL=index.js.map